import { AspectRatio, Box, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'
import ThreeBottle from './three-bottle'
import { MainContainer } from './index'
import Link from 'next/link'

const FeaItem = ({ icon, title }: { icon: any; title: string }) => {
  return (
    <VStack alignItems="center">
      <AspectRatio
        ratio={1}
        w={{
          base: '50px',
          sm: '60px',
          md: '60px',
          lg: '70px',
          xl: '80px'
        }}
      >
        <Image src={icon} alt="icon" fill />
      </AspectRatio>
      <Text
        w={{
          base: '64px',
          sm: '64px',
          md: '64px',
          lg: '80px',
          xl: '80px'
        }}
        textStyle="oralcareFeaTittle"
        textAlign="center"
      >
        {title}
      </Text>
    </VStack>
  )
}

const Hero = () => {
  return (
    <Box
      data-aos="fade-up"
      pt={10}
      w="100%"
      bgColor="#fefefa"
      position="relative"
      mb="80px"
    >
      <Box position="absolute" top={0} left={0}>
        <AspectRatio
          w={{
            base: '150px',
            sm: '230px',
            md: '300px',
            lg: '400px',
            xl: '500px',
            '2xl': '600px'
          }}
          ratio={1537 / 864}
        >
          <Image
            src={
              'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/leaf-hero-left-1714038035204.png'
            }
            alt="leaf left"
            fill
          />
        </AspectRatio>
      </Box>
      <Box position="absolute" top={0} right={0}>
        <AspectRatio
          w={{
            base: '150px',
            sm: '230px',
            md: '300px',
            lg: '400px',
            xl: '500px',
            '2xl': '600px'
          }}
          ratio={1537 / 864}
        >
          <Image
            src={
              'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/leaf-hero-right-1714038035205.png'
            }
            alt="lefa right"
            fill
          />
        </AspectRatio>
      </Box>

      <Flex
        mt={{
          base: '60px',
          sm: '120px',
          lg: '180px',
          xl: '320px'
        }}
        w="100%"
        justifyContent="center"
        alignItems="center"
        flexDir="column"
      >
        <AspectRatio
          w={{
            base: '300px',
            sm: '400px',
            md: '500px',
            xl: '600px'
          }}
          ratio={3508 / 1630}
          ml={{
            base: '40px',
            md: '70px'
          }}
        >
          <Image
            src={
              'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/health-care-1714038035206.png'
            }
            alt="health care"
            fill
          />
        </AspectRatio>

        <Text
          textStyle="oralcareMainTitle"
          textAlign="center"
          fontWeight={400}
          w={{
            base: '80%',
            lg: '60%'
          }}
          zIndex={100}
        >
          OralCare Mouthwash
        </Text>
      </Flex>
      <MainContainer
        mt={{
          base: '80px',
          lg: '120px'
        }}
        data-aos="fade-up"
      >
        <Flex
          gap={10}
          flexDir={{
            base: 'column-reverse',
            md: 'row'
          }}
        >
          <Box flex={1}>
            <Text
              textStyle="oralcareHeroTitle"
              textTransform="uppercase"
              textAlign={{
                base: 'center',
                md: 'left'
              }}
              w="100%"
              zIndex={100}
              color={'#4b7438'}
              textShadow={'0px 4px 4px rgba(0, 0, 0, 0.25)'}
            >
              Healthy Oral Everyday!
            </Text>

            <Flex
              gap={{
                base: 2,
                lg: 2,
                xl: 3
              }}
              mt={{
                base: 6,
                sm: 10
              }}
              justifyContent={{
                base: 'center',
                md: 'flex-start'
              }}
            >
              <FeaItem
                icon={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/child-icon-1714038035207.png'
                }
                title="Suitable For Children"
              />
              <FeaItem
                icon={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/pregnant-icon-1714038035207.png'
                }
                title="Suitable During Pregnancy"
              />
              <FeaItem
                icon={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/teeth-icon-1714038035206.png'
                }
                title="Teeth Whitening"
              />
              <FeaItem
                icon={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/breath-icon-1714038035208.png'
                }
                title="Bad Breath Prevention"
              />
              <FeaItem
                icon={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/plaque-icon-1714038035224.png'
                }
                title="Anti Plaque"
              />
            </Flex>

            <HStack
              mt={6}
              justifyContent={{
                base: 'center',
                md: 'flex-start'
              }}
              gap={0}
            >
              <AspectRatio
                w={{
                  base: '50px',
                  lg: '80px'
                }}
                ratio={1537 / 864}
              >
                <Image
                  src={
                    'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/leaf-icon-1714038035208.png'
                  }
                  alt="health care"
                  fill
                />
              </AspectRatio>

              <VStack gap={0}>
                <Text
                  textStyle="oralcareFeaTittle"
                  textAlign="left"
                  fontWeight={400}
                  w="100%"
                  zIndex={100}
                >
                  Made with
                </Text>
                <Text
                  textStyle="oralcareFeaTittleLarge"
                  textAlign="left"
                  w="100%"
                  zIndex={100}
                >
                  Natural Ingredients
                </Text>
              </VStack>
            </HStack>

            <HStack
              justifyContent={{
                base: 'center',
                md: 'flex-start'
              }}
            >
              <Link href="https://habbit.sg/products/health+oralcare">
                <AspectRatio
                  ratio={1537 / 864}
                  w={{
                    base: '120px',
                    sm: '120px',
                    md: '140px',
                    lg: '160px'
                  }}
                  _hover={{
                    opacity: 0.7
                  }}
                  mt={3}
                >
                  <Image
                    src={
                      'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/buy-now-btn-1714038035225.png'
                    }
                    alt="buy now btn"
                    fill
                  />
                </AspectRatio>
              </Link>
            </HStack>
          </Box>

          <Flex
            flex={1}
            ml={{
              base: '0px',
              md: '-60px',
              lg: '-80px',
              xl: '-60px'
            }}
            flexDir="column"
            justifyContent="center"
            alignItems="center"
          >
            <ThreeBottle />

            <AspectRatio
              ratio={1537 / 318}
              w={{
                base: '350px',
                sm: '400px',
                md: '400px',
                lg: '600px'
              }}
              mt={{
                base: '-50px',
                md: '-70px',
                lg: '-75px'
              }}
              ml={{
                base: '0px',
                lg: '0px'
              }}
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/vase-lining-1714038035225.png'
                }
                alt="vase lining"
                fill
              />
            </AspectRatio>
          </Flex>
        </Flex>
      </MainContainer>
    </Box>
  )
}

export default Hero
